import React from "react";

const Intro = () => {
  const introContent = {
    // TODO use a wider picture here so it doesn't scale as tall
    // fallback plan: change CSS to center it, but only scale to ~70% width
    image: "assets/img/slider/1.jpg",
    name: "Scott Ankiewicz",
    designation: "Backend Developer",
    text: (
      <>
        <p>
          State championship mathlete, puzzle addict, software engineer. I am
          these things and more because I love the &quot;AHA&quot; moments when
          ideas crystallize into solutions. In my medical device development, I
          relied on planning, attention to detail, and effective collaboration
          to solve deeply hidden issues in my devices. If you&apos;d like to
          work with someone with years of experience working on fast paced teams
          and a penchant for solving problems, then let&apos;s talk about the
          puzzles your team is working on.
        </p>
      </>
    ),
  };

  return (
    <>
      <div className="top_author_image">
        <img src={introContent.image} alt="Scott Ankiewicz" />
      </div>
      <div className="about_title">
        <h3>{introContent.name}</h3>
        <span>{introContent.designation}</span>
      </div>
      <div className="about_text">{introContent.text}</div>
    </>
  );
};

export default Intro;
